import { RouteRecordRaw } from "vue-router";
import store from "@/store/blog";

function ixTo3(ix: number) {
  return ("00" + ix).slice(-3);
}

const blogCount = store.state.blogTitles.length;
const blogRoute: RouteRecordRaw = {
  path: "/blog",
  name: "Blog",
  component: () => import("@/views/Blog.vue"),
  children: [],
  redirect: `/blog/${ixTo3(blogCount - 1)}`,
};

for (let ix = 0; ix < blogCount; ix++) {
  const ix3 = ixTo3(ix);
  blogRoute.children?.push({
    name: ix3,
    meta: {
      ix: ix,
      title: store.state.blogTitles[ix],
    },
    path: `/blog/${ix3}`,
    component: () => import(`@/views/Blog/Blog${ix3}.vue`),
  });
}
export default blogRoute;
